/* 2026-10-25 speed: the auto-scroll used to run requestAnimationFrame on every frame forever, on every device,
   and read the strip width each frame. It now runs only while it can actually move the strip (on screen,
   not a phone, motion allowed, not paused, hovered, focused or touched, tab visible) and restarts when that
   changes. Same speed, same controls, same look. */
function fwHomeReviews(root = document) { root.querySelectorAll('.reviews-strip').forEach(strip => {
  if (strip.dataset.fwReady) return; strip.dataset.fwReady = 'true';
  const viewport = strip.querySelector('.reviews-viewport');
  const button = strip.querySelector('.reviews-toggle');
  const group = strip.querySelector('.reviews-group');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const phone = matchMedia('(max-width: 749px)'); /* patch35: phones swipe by hand (peek, snap, hint); no auto-scroll */
  let paused = false, hover = false, focused = false, touching = false;
  let last = 0, position = 0, running = false, visible = !('IntersectionObserver' in window), distance = 0;
  /* page-level listeners and observers are released when the theme editor unloads this section */
  const off = 'AbortController' in window ? new AbortController() : null, opt = off ? { signal: off.signal } : undefined;
  function measure() { distance = group.getBoundingClientRect().width + 16; }
  function active() { return visible && !document.hidden && !motion.matches && !phone.matches && !paused && !hover && !focused && !touching; }
  function kick() {
    if (running || !strip.isConnected || !active()) return;
    running = true; last = 0; position = viewport.scrollLeft;
    requestAnimationFrame(frame);
  }
  function update() {
    button.textContent = paused ? 'Play reviews' : 'Pause reviews';
    button.setAttribute('aria-pressed', String(paused));
    button.disabled = motion.matches;
    if (motion.matches) button.textContent = 'Auto-scroll off';
    kick();
  }
  button.addEventListener('click', () => { paused = !paused; update(); });
  strip.addEventListener('mouseenter', () => { hover = true; });
  strip.addEventListener('mouseleave', () => { hover = false; kick(); });
  strip.addEventListener('focusin', () => { focused = true; });
  strip.addEventListener('focusout', event => { focused = strip.contains(event.relatedTarget); kick(); });
  viewport.addEventListener('pointerdown', () => { touching = true; paused = true; update(); });
  window.addEventListener('pointerup', () => { touching = false; kick(); }, opt);
  window.addEventListener('pointercancel', () => { touching = false; kick(); }, opt);
  viewport.addEventListener('wheel', () => { paused = true; update(); }, {passive:true});
  viewport.addEventListener('keydown', event => {
    if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) { paused = true; update(); }
  });
  const observers = [];
  motion.addEventListener('change', update, opt);
  phone.addEventListener('change', kick, opt);
  document.addEventListener('visibilitychange', kick, opt);
  if ('ResizeObserver' in window) { const ro = new ResizeObserver(measure); ro.observe(group); observers.push(ro); } else window.addEventListener('resize', measure, opt);
  if (!visible) { const io = new IntersectionObserver(entries => { visible = entries[entries.length - 1].isIntersecting; kick(); }); io.observe(strip); observers.push(io); }
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(strip)) return;
    if (off) off.abort(); observers.forEach(o => o.disconnect());
  }, opt);
  function frame(now) {
    if (!strip.isConnected || !active()) { running = false; position = viewport.scrollLeft; return; }
    const elapsed = last ? Math.min(now - last, 80) : 16; last = now;
    if (!distance) measure();
    if (Math.abs(viewport.scrollLeft - position) > 2) position = viewport.scrollLeft;
    position = (position + distance * elapsed / 40000) % distance;
    viewport.scrollLeft = position;
    requestAnimationFrame(frame);
  }
  update();
});

}
fwHomeReviews();
document.addEventListener("shopify:section:load", event => fwHomeReviews(event.target));
